<template>
  <div class="SalesReport">
    <ReportPanel
      v-if="report"
      :title="title"
      :status="report.status">
      <div class="panel-body">
        <div class="report-table">
          <div class="head">
            <div class="cell col1">
              Gender/age
            </div>
            <div class="cell col2">
              Member
            </div>
            <div class="cell col3">
              Type of customer
            </div>
            <div class="cell col4">
              Location
            </div>
            <div class="cell col5">
              Amount
            </div>
            <div class="cell col6">
              Delete
            </div>
          </div>

          <div class="body">
            <SalesReportReadItem
              class="show-phone"
              v-for="item of report.salesReportItemsList"
              :read-only="readOnly"
              :key="'ro' + item.id"
              :item="item" />

            <SalesReportItem
              class="hide-phone"
              @sales-report-item-updated="handleSalesReportItemUpdated"
              @sales-report-item-deleted="refresh"
              v-for="item of report.salesReportItemsList"
              :key="'rw' + item.id"
              :read-only="readOnly"
              :item="item" />
          </div>
        </div>
        <!-- report-table -->
      </div>
      <!-- panel-body -->
      <div
        v-if="!readOnly"
        class="add-member">
        <span
          class="hide-phone"
          @click="addSalesReportItem()">
          <Icon name="plus" />
          Add member</span>
        <span
          class="show-phone"
          @click="addSalesReportItem(true)">
          <Icon name="plus" />
          Add member</span>
      </div>

      <div class="total">
        <div class="footer-item total-label">
          Total amount:
        </div>
        <div class="footer-item total-amount">
          <b>{{ total }} NOK</b>
        </div>
      </div>

      <div class="panel-footer">
        <div class="footer-item save">
          <IconButton
            v-if="report.status === 'DRAFT'"
            class="cta2 small"
            @click="save()"
            icon="save">
            Save draft
          </IconButton>
        </div>
        <div class="hide-phone footer-item total-label">
          Total amount:
        </div>
        <div class="hide-phone footer-item total-amount">
          <b>{{ total }} NOK</b>
        </div>
        <div class="footer-item submit">
          <IconButton
            icon="send"
            class="small"
            v-if="report.status === 'DRAFT' && confirm==false"
            @click="confirm=true">
            Submit report
          </IconButton>
          <div class="confirm-buttons">
            <IconButton
              v-if="confirm"
              icon="send"
              class="small confirm-submit"
              @click="submitReport()">
              Confirm {{ period }}
            </IconButton>
            <IconButton
              v-if="confirm"
              icon="close"
              class="small"
              @click="confirm=false">
              Cancel
            </IconButton>
          </div>
        </div>
      </div>
      <!-- panel-footer -->
    </ReportPanel><!-- panel -->
  </div>
  <!-- SalesReport -->
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import ReportPanel from "@/components/ReportPanel";
import SalesReportItem from "@/components/SalesReportItem";
import SalesReportReadItem from "@/components/SalesReportReadItem";

export default {
  components: { SalesReportItem, SalesReportReadItem, ReportPanel },
  data: function () {
    return {
      report: null,
      confirm: false,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  filters: {
    period(val) {
      return moment(val).format("MMMM YYYY");
    },
  },

  computed: {
    title() {
      return `Sales Report ${this.period}`;
    },

    period() {
      return moment(this.report.periodStart).format("MMMM YYYY");
    },

    total() {
      return this.report.salesReportItemsList.reduce((acc, item) => {
        return acc + parseInt(item.amount);
      }, 0);
    },

    readOnly() {
      return this.report.status === "SUBMITTED";
    },
  },

  methods: {
    refresh() {
      this.$apollo.queries.report.refresh();
    },
    navigateToReports() {
      this.$router.push({ name: "reports" });
    },

    save() {
      this.navigateToReports();
    },

    submitReport() {
      console.log("submitting report");
      this.$apollo
        .mutate({
          mutation: gql`
            mutation UpdateSalesReportMutation($id: UUID!) {
              updateSalesReport(
                input: { patch: { status: SUBMITTED }, id: $id }
              ) {
                clientMutationId
              }
            }
          `,
          variables: { id: this.report.id },
        })
        .then((response) => {
          this.$emit("sales-report-updated", response);
          this.navigateToReports();
        })
        .catch((err) => {
          console.error("failed to submit sales report", err);
        });
    },

    addSalesReportItem(redirect) {
      console.log("adding sales report item");
      this.$apollo
        .mutate({
          mutation: gql`
            mutation CreateSalesReportItemMutation($salesReportId: UUID!) {
              createSalesReportItem(
                input: {
                  salesReportItem: {
                    salesReportId: $salesReportId
                    customerType: NEWSALE
                  }
                }
              ) {
                clientMutationId
                salesReportItem {
                  id
                }
              }
            }
          `,
          variables: { salesReportId: this.report.id },
        })
        .then((response) => {
          this.$emit("sales-report-updated", response);
          this.refresh();
          if (redirect === true) {
            this.$router.push({
              name: "sales-report-item",
              params: {
                id: response.data.createSalesReportItem.salesReportItem.id,
                created: true,
              },
            });
          }
        })
        .catch((err) => {
          console.error("failed to add new sales report item", err);
        });
    },

    handleSalesReportItemUpdated() {
      console.log("handleSalesReportItemUpdated");
      this.$emit("sales-report-updated");
    },
  },

  mounted() {},

  apollo: {
    report() {
      return {
        fetchPolicy: "no-cache",
        query: gql`
          query SalesReportQuery($id: UUID!) {
            salesReport(id: $id) {
              id
              periodEnd
              periodStart
              status
              salesReportItemsList(
                orderBy: ID_ASC
                condition: { deleted: false }
              ) {
                deleted
                amount
                customerType
                id
                location {
                  id
                  name
                }
                membership {
                  id
                  location {
                    id
                    name
                  }
                  customer {
                    id
                    firstName
                    lastName
                    gender
                    birthdate
                  }
                }
              }
            }
          }
        `,
        variables: { id: this.id },
        update: (data) => data.salesReport,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/responsive.scss";

.SalesReport {
  padding: 1em;
  display: flex;

  .report-table {
    padding-top: 1em;
    display: flex;
    flex-direction: column;

    .head {
      display: flex;
      flex: 1;
      box-shadow: inset 0 -1px 0 0 var(--slate);
      font-weight: bold;
      opacity: 0.5;
      padding-bottom: 1em;
      @include phone {
        display: none;
      }
    }

    .body {
      padding-top: 1em;
      display: flex;
      flex: 1;
      flex-direction: column;
    }

    .cell {
      display: flex;
      padding: 1em;
      padding-left: 0;
    }

    .col1 {
      width: 10%;
    }

    .col2 {
      width: 25%;
    }

    .col3 {
      width: 20%;
    }

    .col4 {
      width: 20%;
    }

    .col5 {
      width: 20%;
    }

    .col6 {
      width: 10%;
      text-align: center;
      padding-left: 2em;
    }
  }

  .panel-footer {
    padding-top: 1em;
    display: flex;
    align-items: baseline;
    justify-content: space-around;
    @include phone {
      justify-content: space-between;
    }
  }

  .total {
    display: none;
    justify-content: space-between;
    padding-top: 1em;
    padding-bottom: 1em;
    font-weight: bold;
    @include phone {
      display: flex;
    }
  }

  .footer-item {
    font-size: 1.14em;
  }

  @include phone {
    .panel-footer {
      flex-wrap: wrap;
    }
    .total-label {
      order: 0;
    }

    .total-amount {
      order: 1;
    }

    .footer-item.save {
      order: 3;
    }

    .footer-item.submit {
      order: 4;
    }
  }

  .add-member {
    text-align: right;
    margin-left: auto;
    font-weight: bold;
    font-size: 1.14em;
    color: var(--blue-purple);
    padding: 1em;
    @include phone {
      text-align: left;
      border-bottom: 1px solid var(--heather);
      padding-left: 0;
    }
    span {
      cursor: pointer;
    }
  }

  .confirm-buttons {
    display: flex;
    .confirm-submit {
      background-color: red;
      margin-right: 5px;
    }
  }
}
</style>
